type SuiteLike = {
  name: string | null | undefined;
  displayName?: string | null | undefined;
};

const trimToNull = (value: string | null | undefined): string | null => {
  const trimmed = value?.trim();
  return trimmed && trimmed.length > 0 ? trimmed : null;
};

export const resolveSuiteEntityDisplayName = (
  suite: SuiteLike,
  options?: { preferFileNameOverDisplayName?: boolean },
): string => {
  const canonicalName = trimToNull(suite.name);
  const displayName = trimToNull(suite.displayName);

  if (options?.preferFileNameOverDisplayName) {
    return canonicalName ?? displayName ?? 'Unknown suite';
  }

  return displayName ?? canonicalName ?? 'Unknown suite';
};

export const resolveSuiteEntitySecondaryLabel = (
  suite: SuiteLike,
  options?: { preferFileNameOverDisplayName?: boolean },
): string | null => {
  const canonicalName = trimToNull(suite.name);
  const displayName = trimToNull(suite.displayName);

  if (!canonicalName || !displayName || canonicalName === displayName) {
    return null;
  }

  return options?.preferFileNameOverDisplayName ? displayName : canonicalName;
};

export const isSuiteFileName = (value: string | null | undefined): boolean => {
  const suiteName = trimToNull(value);
  if (!suiteName) return false;

  const normalisedSuiteName = suiteName.replaceAll('\\', '/');
  const pathSegments = normalisedSuiteName.split('/');
  const filename = pathSegments[pathSegments.length - 1] ?? normalisedSuiteName;

  return pathSegments.length > 1 && /\.[A-Za-z0-9]+$/.test(filename);
};
